import axios from "axios";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API_BASE, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config;
    const url = cfg?.url || "";
    if (err.response?.status === 401 && !cfg._retry && !url.startsWith("/auth/") && !url.startsWith("/portal")) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        return api(cfg);
      } catch {
        window.dispatchEvent(new Event("auth:logout"));
      } finally {
        refreshing = null;
      }
    }
    return Promise.reject(err);
  }
);

export const errMsg = (e, fallback = "Something went wrong") => {
  const d = e?.response?.data?.detail;
  if (!d) return fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || fallback;
};

export const money = (n, currency = "USD") => {
  if (n === null || n === undefined || isNaN(Number(n))) return "—";
  try {
    const compact = Math.abs(n) >= 1e6;
    const cents = !compact && Math.round(Number(n) * 100) % 100 !== 0;
    return new Intl.NumberFormat("en-US", { style: "currency", currency, notation: compact ? "compact" : "standard", minimumFractionDigits: cents ? 2 : 0, maximumFractionDigits: compact || cents ? 2 : 0 }).format(n);
  } catch {
    return `${Number(n).toLocaleString()} ${currency}`;
  }
};

export const scoreTone = (s) => (s >= 75 ? "emerald" : s >= 50 ? "amber" : "rose");

export const logoUrl = (v) => `${API_BASE}/public/logo?v=${encodeURIComponent(v || "")}`;

export const downloadBlob = async (url, filename) => {
  const r = await api.get(url, { responseType: "blob" });
  const href = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = href;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(href);
};

export const applyBrand = (brand) => {
  if (!brand) return;
  const root = document.documentElement.style;
  Object.entries(brand).forEach(([k, v]) => root.setProperty(`--brand-${k}`, v));
};
